import React,{useState,useEffect} from "react";
import { Link } from "react-router-dom";
import { getPrincipalMessage } from "../Service/Api";
import LazyLoad from "react-lazyload";

const Message = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const principalData1 = await getPrincipalMessage();
         const principalData =principalData1.filter((item) => item.category ==='Principal' )
        setData(principalData);
      } catch (error) {
        console.log("Data Error", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
 
  return (
    <>
           {data.length > 0  && (
           <div className="message-container">
          <div className="messagebox">
            <div className="messagedesc"> 
              <div className="msginfo">
                    <div dangerouslySetInnerHTML={{ __html: data[0].message }} />
               </div>
            </div>  
          </div> 
          <div className="messageimg">
            <div className="testimonialimg"> 
            <LazyLoad> 
            {data[0].attachments && data[0].attachments.length > 0 ? (<img
              src={`https://webapi.entab.info/api/image/${data[0].attachments}`}
              alt="SPCSH"
              className="img-fluid"
            />) : (<img src="https://webapi.entab.info/api/image/MMATD/public/Images/dummy.jpg" alt="SPCSH" className="img-fluid" />)}
            </LazyLoad>
            </div>
            <div className="messageboximg">
              <p>{data[0].name} <span> {data[0].category}</span> </p> 
            </div>
            <div className="mainbtn button">
              <div className="readmore"> <Link to="/PrincipalMessage"><img src="https://webapi.entab.info/api/image/MMATD/public/Images/btn.png" className="img-fluid mx-auto d-block" alt="Mary Matha CMI Academy"/></Link></div>
              </div>
          </div>
        </div>
          )}
          {data.length === 0  && (
            <div className="message-container">
            <div className="messagebox">
              <div className="messagedesc"> 
                <p><b>Dear Parents and students,</b></p>
                <p>  Our prestigious School has most successfully entered into 27 th year of excellent educational service striving with sincere dedication to nurture the future of all children entrusted to our care. It is a matter of soulful solace that God continues to shower his plentiful blessing through the powerful intercession of St. Kuriakose Elias Chavara the founder of CMI Congregation. Mother Marty, the heavenly patron of school continues to watch over us protecting us from any eventual calamity. As we march ahead with great success stories in academic and non-academic, I am impelled to share a soul-stirring thought that has been overwhelmingly occupying my mind.  We live in the ultra-modern era o knowledge explosion. All kinds of information and knowledge are available at the click of the mouse and at the tip of our fingers on the touch screen mobiles. With the arrival of latest technologies the role of parents and teachers are imminently tending to be replaced. electronic gadgets such as mobile phones and iPods are apparently trying to shrink social relationship. Social media platforms have become the driving force for each one's existence.</p>
                 <p> With concerted efforts by parents and teachers we can make a differences by instill human values among the children of today and wean them away from the virtual world. Students must have prudent discernment between unrealistic media world and the real day today struggle filled but meaningful life. I have endless optimism in the goodness of parents and teaching community. Through systematic planning, team work and dedicated efforts we can mould our children and form them for others with competence, compassion and conviction. 
                  Let's strive for excellence in upholding human values. God bless all. </p>
                </div>  
            </div> 
            <div className="messageimg">
              <div className="testimonialimg">
                <LazyLoad><img src="https://webapi.entab.info/api/image/MMATD/public/Images/Principal.png" alt="MMATD" className="img-fluid" /></LazyLoad>
              </div>
              <div className="messageboximg">
                <p>
                Principal Name<span> Principal</span> 
                </p>
              </div>
              <div className="mainbtn button">
              <div className="readmore"> <Link to="/PrincipalMessage"><img src="https://webapi.entab.info/api/image/MMATD/public/Images/btn.png" className="img-fluid mx-auto d-block" alt="Mary Matha CMI Academy"/></Link></div>
              </div>
            </div>
          </div>
          )}   
 
    </>
  );
};

export default Message;
